export default __webpack_public_path__ + "static/media/truck.81e178bc.jpg";